import {
    Button,
    Col,
    Container,
    Dropdown,
    Form,
    Modal,
    OverlayTrigger,
    Row,
    Table,
    Tooltip,
} from "react-bootstrap";
import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import { ThreeDotSpinner } from "../loader";
import {
    dateFormate,
    formatWalletAddress,
    formatWithDecimals,
    transactionurl,
} from "../../config/config";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import { apiService } from "../../service/api.service";
import Select from "react-select";
import LineChart from "../../common/LineChart";
import { CopyToClipboard } from "react-copy-to-clipboard";


export const ScoresPredictionResultFailed = () => {
    const [page, setPage] = useState(1);
    const [transactions, settransactions] = useState([]);
    const [transactionIds, setTransactionIds] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [loader, setLoader] = useState(false);
    const [filterValue, setFilterValue] = useState('FAILED');
    const [copied, setcopied] = useState(false);

    const filterOptions = [
        // { value: "", label: "All" },
        { value: "EXECUTABLE", label: "Executable" },
        { value: "FAILED", label: "Failed" },
        { value: "PENDING", label: "Pending" },
    ];

    const statusDropdown = [
        {
            name: "FAILED",
            id: "FAILED",
        },
        {
            name: "PENDING",
            id: "PENDING",
        },
    ];


    useEffect(() => {
        transaction_list(page);
    }, []);

    const copytooltip = (
        <Tooltip id="tooltip">{copied ? "Copied" : "Copy"}</Tooltip>
    );


    async function transaction_list(page) {
        setLoader(true);
        try {
            let params = {
                page: page - 1,
            }
            const response = await apiService.get_scores_prediction_result_failed(params);
            if (response?.status == 200) {
                console.log("response.data.data", response?.data?.data?.totalRecords);
                let totalItems = response.data?.data?.totalRecords ? response.data?.data?.totalRecords : 0
                let list = response.data.data?.list ? response.data.data?.list : null
                settransactions(list);
                setTotalItems(totalItems);
                setLoader(false);
            }

        } catch (error) {
            if (error?.response?.status == 401) {
                setLoader(false);
                swal({ icon: "error", text: "Unauthorized", button: "OK" }).then(() => {
                    localStorage.clear();
                    window.location.href = "/";
                    console.log("OK button clicked after error alert");
                });
            } else {
                setLoader(false);
                swal({
                    icon: "error",
                    text: error?.response?.data?.message
                        ? error?.response?.data?.message
                        : error?.message,
                    button: "OK",
                }).then(() => {
                    console.log("OK button clicked after error alert");
                });
            }
        }
    };


    function handlePageChange(pageNumber) {
        if (page != pageNumber) {
            setPage(pageNumber);
            transaction_list(pageNumber, filterValue);
            setTransactionIds([]);
        }
    };


    function handleStatusConfimation(transactionId, status) {
        let actionType = status == "FAILED" ? "PENDING" : "FAILED"
        swal({
            title: 'Are you sure?',
            text: `Are you sure you want to change status ${status} to ${actionType}?`,
            icon: 'warning',
            buttons: ['Cancel', `Yes, ${actionType}`],
            dangerMode: true,
        }).then((confirmed) => {
            if (confirmed) {
                handleTransactionStaus(transactionId, actionType);
            }
        })
    };


    async function handleTransactionStaus(transactionIds, status) {
        try {
            const response = await apiService.result_transaction_status_change(transactionIds, status);
            if (response.status === 200) {
                setLoader(true);
                if (transactions?.length == 1) {
                    setPage(1)
                    transaction_list(1);
                }
                else {
                    transaction_list(page);
                }
            }
        }
        catch (error) {
            if (error?.response?.status == 401) {
                setLoader(false);
                swal({ icon: "error", text: "Unauthorized", button: "OK" }).then(() => {
                    localStorage.clear();
                    window.location.href = "/";
                    console.log("OK button clicked after error alert");
                });
            } else {
                setLoader(false);
                swal({
                    icon: "error",
                    text: error?.response?.data?.message
                        ? error?.response?.data?.message
                        : error?.message,
                    button: "OK",
                }).then(() => {
                    console.log("OK button clicked after error alert");
                });
            }
        }
    };



    return (
        <div className="dashboard-main-area">
            {loader == true ? <ThreeDotSpinner /> : ""}
            <Container fluid>
                <div className="dashboard-area-heading management-heading">
                    <Row className="row justify-content-center align-items-center mb-3">
                        <Col md={12} lg={11}>
                            <div className="heading-top-area">
                                <div className="d-flex ">
                                    <h2 className="align-self-center m-0">Scores Prediction Result Failed</h2>
                                </div>

                            </div>
                        </Col>
                    </Row>
                    <Row className="pb-4 justify-content-center">
                        <Col md={12} lg={11}>
                            <div className="audit-request-box">
                                <Table responsive="sm" className="UserListTable">
                                    <thead>
                                        <tr>

                                            <th>Sr. No.</th>
                                            <th>Prediction Name</th>
                                            <th>Prediction Type</th>
                                            <th>Data Provider</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Amount</th>
                                            <th>Prediction Status</th>
                                            <th>Contract Address</th>
                                            <th>Status</th>
                                            {/* <th>View Transaction</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {totalItems != null &&
                                            totalItems > 0 &&
                                            transactions &&
                                            transactions?.length > 0 ? (
                                            transactions.map((data, index) => {
                                                const serialNumber = (page - 1) * 10 + index + 1;
                                                let predictionDetail = data.params && data.params.length > 0 ? data.params[0] : ''

                                                let predictionQuestion = data?.question ? data.question : ''
                                                let predictionName = predictionQuestion && predictionQuestion.length > 50 ? predictionQuestion.slice(0, 50) + "..." : predictionQuestion

                                                let predictionType = data?.prediction_type ? data?.prediction_type === "RISK-FREE" ? "Prize pool" : predictionDetail?.prediction_type : "N/A"

                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {predictionQuestion.length > 50 ? (
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            {predictionQuestion}
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="hover-text">
                                                                        {predictionQuestion.substring(0, 50)}...
                                                                    </span>
                                                                </OverlayTrigger>
                                                            ) : (
                                                                predictionQuestion
                                                            )}
                                                        </td>
                                                        <td>
                                                            {predictionType}
                                                            {data?.prediction_category !== "REGULAR" && (
                                                                <>
                                                                    {data?.prediction_category === "POLL" && " ( POLL )"}
                                                                    {data?.prediction_category === "QUIZ" && " ( QUIZ )"}
                                                                    <span className="capitalized">
                                                                        &nbsp; {data?.solo_type}
                                                                    </span>

                                                                </>
                                                            )}
                                                        </td>
                                                        <td style={{ textTransform: 'capitalize' }}> {data?.data_provider ? data.data_provider : "N/A"}</td>
                                                        <td> {data?.startDateTime ? moment(data.startDateTime).format(dateFormate) : "N/A"}</td>
                                                        <td>{data?.endDateTime ? moment(data.endDateTime).format(dateFormate) : "N/A"}</td>
                                                        <td>
  {data?.amount ? `${formatWithDecimals(data.amount, data.decimal)} ( ${data.symbol
} )` : "N/A"}
</td>


                                                        <td>{data?.prediction_status || "N/A"}</td>
                                                        <td> {formatWalletAddress(data.contract_address)}
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={copytooltip}
                                                            >
                                                                <CopyToClipboard
                                                                    text={data.contract_address}
                                                                    onCopy={() => setcopied(true)}
                                                                >
                                                                    <i
                                                                        class="fa fa-clipboard"
                                                                        style={{ cursor: "pointer" }}
                                                                        aria-hidden="true"
                                                                    ></i>
                                                                </CopyToClipboard>
                                                            </OverlayTrigger></td>
                                                        <td>

                                                            {
                                                                <Dropdown>
                                                                    <Dropdown.Toggle
                                                                        variant={data.transaction_status == "FAILED" ? "danger" : "success"}
                                                                        id="dropdown-basic">
                                                                        {data.transaction_status}
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        {
                                                                            statusDropdown.map((item) => (
                                                                                data.transaction_status !== item.id &&
                                                                                <Dropdown.Item className="item-on-dropdown"
                                                                                    onClick={() => handleStatusConfimation(data._id, data.transaction_status)}
                                                                                >
                                                                                    {item.name}
                                                                                </Dropdown.Item>
                                                                            ))
                                                                        }
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )
                                            : (
                                                <tr className="no-dat-found-box">
                                                    <td colSpan={10}>
                                                        <img
                                                            src={
                                                                require("../../assets/images/no-data.svg")
                                                                    .default
                                                            }
                                                            alt="da"
                                                        />
                                                        <h3 className="text-center text-light">
                                                            No data found
                                                        </h3>
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </Table>

                                {totalItems && totalItems > 0 ? (
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={10}
                                        totalItemsCount={totalItems}
                                        pageRangeDisplayed={5}
                                        onChange={(e) => handlePageChange(e)}
                                        prevPageText={"Prev"}
                                        nextPageText={"Next"}
                                    />
                                ) : null}
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>

        </div>
    );
};
